<template>
  <div>
  <vx-card ref="filterCard" title="시험 시간" class="user-list-filters mb-8">
    <div class="vx-row">
      <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <label class="text-sm opacity-75">제목</label>
        <h3 style="margin-bottom:5px;">{{ActiveOnlineTest.title}}</h3>
      </div>
      <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <label class="text-sm opacity-75">시험일시</label>
        <h3 style="margin-bottom:5px;">{{ActiveOnlineTest.start_time | date }} {{ActiveOnlineTest.start_time | time }}</h3>
      </div>
      <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <label class="text-sm opacity-75">시험시간</label>
        <h3 style="color:#ff4040; margin-bottom:5px;">{{ActiveLimitTime}}</h3>
      </div>
      <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <vs-button color="dark" @click="goTestPage(ActiveOnlineTest.id)">시험보기</vs-button>
      </div>
    </div>
  </vx-card>

    <div id="email-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">

        <!-- <vs-sidebar class="items-no-padding" parent="#email-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isEmailSidebarActive">
            <email-sidebar :emailTags="emailTags" @closeSidebar="toggleEmailSidebar" :mailFilter="mailFilter" />
        </vs-sidebar> -->
        <div class="items-no-padding no-scroll-content border d-theme-border-grey-light border-r-0 border-t-0 border-b-0">

            <!-- SEARCH BAR -->
            <div class="flex border d-theme-dark-bg items-center">
                <!-- <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" v-if="activeUserLevel >= 3 && activeSpaceInfo.service" @click.stop="toggleEmailSidebar(true)"/> -->
                <!-- <vs-input icon-no-border icon="icon-search" size="large" icon-pack="feather" placeholder="Search Mail" v-model="searchQuery" class="vs-input-no-border vs-input-no-shdow-focus w-full" /> -->
                <vs-input icon-no-border icon="icon-search" size="large" icon-pack="feather" placeholder="검색"  v-model="searchQuery" class="vs-input-no-border vs-input-no-shdow-focus w-full" />
            </div>

            <!-- EMAIL ACTION BAR -->
            <div class="email__actions flex items-center flex-wrap justify-between p-4 border border-r-0 border-l-0 border-solid d-theme-border-grey-light">
                <div class="flex items-center">
                    <!-- <vs-checkbox v-model="selectAllCheckBox" icon-pack="feather" :icon="selectAllIcon" class="select-all-chexkbox ml-0">Select All</vs-checkbox> -->
                </div>
                <div class="flex" :click-not-close="clickNotClose" :hidden-background="clickNotClose">
                    <feather-icon v-if="activeUserLevel >= 3 && activeSpaceInfo.service" icon="EditIcon" class="ml-5 cursor-pointer" svg-classes="h-6 w-6"  @click="activePrompt = true" />
                    <!-- <feather-icon v-if="mailFilter != 'trash'" icon="TrashIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="moveTo('trash')" /> -->
                </div>
            </div>
            <!-- compose email -->
            <vs-prompt
                class="email-compose"
                title="온라인 시험"
                accept-text= "업로드"
                cancel-text= "취소"
                @cancel="clearFields"
                @close="clearFields"
                @accept="createOnlineTest"
                :active.sync="activePrompt">
                <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
                    <form @submit.prevent>
                      <div class="mt-4" v-if="shareClass.length > 0">
                        <!-- <label class="text-sm">수업 동기화</label> -->
                        <v-select placeholder="동기화 수업 없음" v-model="languages_known" multiple :closeOnSelect="false" :options="shareClass" v-validate="'required'" name="lang_known" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                        <!-- <span class="text-danger text-sm"  v-show="errors.has('lang_known')">{{ errors.first('lang_known') }}</span> -->
                      </div>
                        <vs-input name="title" label-placeholder="제목" v-model="title" class="w-full mb-6" />
                        <div class="mb-2">
                          <label style="margin-right:10px;">시험날짜</label>
                          <!-- <flat-pickr :config="configFromdateTimePicker" v-model="fromDate" placeholder="시작 시간" @on-change="onFromChange" style="margin-right:10px; margin-bottom:5px;"/>
                          <flat-pickr :config="configTodateTimePicker" v-model="toDate" placeholder="종료 시간" @on-change="onToChange"/> -->
                          <flat-pickr :config="configdateTimePicker" v-model="datetime" placeholder="시험날짜&시간입력" />
                        </div>
                        <div class="mb-2">
                          <label style="margin-right:10px;">제한시간</label>
                          <flat-pickr :config="configdateonlyTimePicker" v-model="limitTime" placeholder="제한시간" label-placeholder="제한시간" />
                        </div>
                        <quill-editor v-model="message" :options="editorOption" />
                        <div class="vx-row lg:w-full" style="margin-top:30px; margin-left:2px; margin-right:2px; margin-bottom:-12px; padding:3px;">
                          <div class="w-full" v-for="(item, index) in fileList" v-bind:key="index" style="margin-top:35px; margin-bottom:-3px;">
                            <div class="vx-card text-center" style="margin-top:-20px; margin-bottom:-3px; margin-right:8px; padding:5px;">
                              <div class="vx-card__collapsible-content" style="text-align:center;">
                                <div class="vx-row" style="margin:5px; ">
                                  <div  style="width: 90%;">
                                    <div align="left" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;">
                                      {{item.name}}
                                    </div>
                                  </div>
                                  <div class="vx-row justify-end" style="width:10%; margin-top:-2px; margin-left:5px; margin-bottom:-3px;">
                                    <vs-button radius color="danger" type="flat" size="small" icon-pack="feather" icon="icon-x" @click="deletefiles(index)"/>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="filebox" style="margin-top:30px;">
                          <label for="inputFile">첨부 파일</label>
                          <input type="file" @change="updateFile" id="inputFile"  name="inputFile" multiple>
                        </div>
                      </form>
                    </form>
                </component>
            </vs-prompt>
            <!-- EMAILS LIST -->
            <component :is="scrollbarTag" class="email-content-scroll-area" :settings="settings" ref="mailListPS" :key="$vs.rtl">
                <transition-group name="list-enter-up" class="email__mails mail__mail-item sm:px-4 px-2 py-6" tag="ul" appear>
                    <li class="cursor-pointer email__mail-item" v-for="(onlineTest) in onlineTests" :key="onlineTest.id" @click="updateOpenOnlineTest(onlineTest.id)" >
                      <!-- <mail-item :mail="mail" :isSelected="isMailSelected(mail.id)" @addToSelected="addToselectedNotice" @removeSelected="removeSelectedMail" /> -->
                      <onlineTest-item :onlineTest="onlineTest"/>
                    </li>
                </transition-group>
            </component>
        </div>

        <!-- EMAIL VIEW SIDEBAR -->
        <onlineTest-view
            :openOnlineTestId    = "openOnlineTestId"
            :isSidebarActive = "isSidebarActive"
            @markUnread      = "activePrompt = true"
            @previousMail    = "previousOnlineTest"
            @nextMail        = "nextOnlineTest"
            @moveTo          = "moveCurrentTo"
            @closeSidebar    = "closeOnlineTestViewSidebar">
        </onlineTest-view>
        <vs-prompt
        title="파일 업로드중"
        :buttons-hidden="true"
        :active.sync="uploadPrompt">
          <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
            <label style="margin-left:10px; margin-top:20px; padding-top:5px; margin-bottom:3px;">파일 업로드중 - 조금만 기다려주세요 :)</label>
            <div class="vx-row lg:w-full" style="margin-top:3px; margin-left:2px; margin-bottom:15px; margin-right:2px; padding:3px;">
              <vs-progress indeterminate color="primary"></vs-progress>
            </div>
          </component>
        </vs-prompt>
    </div>
  </div>
</template>

<script>
import OnlineTestItem from "@/views/apps/space/dashboard/onlineTest/OnlineTestItem.vue"
import OnlineTestView from "@/views/apps/space/dashboard/onlineTest/OnlineTestView.vue"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleOnlineTest from '@/store/onlineTest/moduleOnlineTest.js'
import { quillEditor } from 'vue-quill-editor'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import vSelect from 'vue-select'

export default {
  props: ['onlineTestId'],
  data() {
    return {
      languages_known:'',
      limitTime: "1:00",
      configdateonlyTimePicker: {
        enableTime: true,
        noCalendar: true,
        time_24hr: true
      },
      dataStateList:{
        now:[],
        today:[],
        day:[],
      },
      ActiveLimitTime:'',

      datetime: new Date(),
      configdateTimePicker: {
       enableTime: true,
       dateFormat: 'Y-m-d H:i'
      },
      showThread           : false,
      settings             : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30,
      },
      activePrompt         : false,
      selectedOnlineTest       : [],
      openOnlineTestId         : null,
      clickNotClose        : true,
      onlineTests              : [],
      title                : '',
      message              : '',
      searchQuery          : '',
      isSidebarActive      : false,
      fileList             : [],
      uploadPrompt         : false,
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'link', 'blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'font': [] }],
          ],
        },
        placeholder: '공지사항 내용을 입력해주세요 :)'
      },
    }
  },
  computed: {
    shareClass() { return this.$store.state.space.shareClass },
    scrollbarTag() { return this.$store.getters.scrollbarTag },
    windowWidth() {
      return this.$store.state.windowWidth
    },
    currentOnlineTest() {
      return this.$store.getters['onlineTest/getOnlineTest'](this.openOnlineTestId)
    },
    onlineTestList() {
      return this.$store.state.onlineTest.onlineTests
    },
    activeUserLevel() {
      return this.$store.state.space.ActiveDashBoardLevel
    },
    activeSpaceInfo() {
      return this.$store.state.space.ActiveSpaceInfo
    },
    ActiveOnlineTest(){
      return this.$store.state.onlineTest.ActiveOnlineTest
    }
  },
  watch: {
    searchQuery(){
      this.$store.commit('onlineTest/SET_ONLINETEST_SEARCH_QUERY', this.searchQuery)
      this.onlineTests = this.$store.getters['onlineTest/filteredOnlineTest']
    }
  },
  methods: {
    updateFile(){
      var size = 0
      for(var index = 0; index <  document.getElementById("inputFile").files.length; index++) {
        var file = document.getElementById("inputFile").files[index]
        size = size + file.size
        if (size > this.$store.state.uploadFileMaxSize) {
          this.fileList = []
          this.$vs.notify({
            color: 'danger',
            title: '에러',
            text: '첨부파일 용량은 15M까지 사용가능합니다'
          })
          break
        }
        if (this.fileList.findIndex(function(item){return item.name == file.name}) == -1) {
          this.fileList.push(file)
        }
      }
    },
    acceptAlert() {
      this.$router.push('/apps/space')
    },
    clearFields() {
      this.$nextTick(() => {
        this.title = ''
        this.message = ''
      })
    },
    createOnlineTest () {
      this.uploadPrompt = true
      var startTime = this.$moment(this.datetime).format('YYYY-MM-DD HH:mm')
      var endTime = this.$moment(this.datetime, 'YYYY-MM-DD HH:mm')
      var limit = this.$moment(this.limitTime, 'HH:mm')
      endTime.add(limit.hours(), 'hours')
      endTime.add(limit.minutes(), 'minutes')
      var shareClass = []
      for (var i in this.languages_known){
        shareClass.push(this.languages_known[i].value)
      }
      this.$store.dispatch('onlineTest/createOnlineTest', {param:{title: this.title, workspace_id: this.$store.state.space.ActiveSpaceInfo.id, detail:this.message,
      start:startTime, timeout:this.limitTime, end:endTime, size:this.fileList.length, "share_class":shareClass}, files:this.fileList}).then((resolve) => {
        this.onlineTests = this.$store.state.onlineTest.onlineTests
        var t1 = this.$moment(new Date()).format('YYYY-MM-DD HH:mm')
        var index = this.onlineTests.findIndex(function(item){return item.id == resolve.data.data.id})
        this.setDateState(index, resolve.data.data, t1)
        this.setActiveOnlinetest()
        this.uploadPrompt = false
      }).catch(() => {
        this.uploadPrompt = false
        this.$vs.notify({
          color: 'danger',
          title: '에러',
          text: '관리자에게 문의해 주세요'
        })
      })
      this.clearFields()
    },
    // removeOpenOnlineTest() {
    //   this.selectedOnlineTest = [this.openOnlineTestId]
    //   this.isSidebarActive = false
    // },
    nextOnlineTest() {
      const currentOnlineTestIndex = this.onlineTestList.findIndex((onlineTest) => onlineTest.id == this.openOnlineTestId)
      if (this.onlineTestList[currentOnlineTestIndex + 1]){
        this.openOnlineTestId = this.onlineTestList[currentOnlineTestIndex + 1].id
      }
    },
    previousOnlineTest() {
      const currentOnlineTestIndex = this.onlineTestList.findIndex((onlineTest) => onlineTest.id == this.openOnlineTestId)
      if (this.onlineTestList[currentOnlineTestIndex - 1]){
        this.openOnlineTestId = this.onlineTestList[currentOnlineTestIndex - 1].id
      }
    },
    closeOnlineTestViewSidebar() {
      this.isSidebarActive = false
    },
    moveCurrentTo(to) {
      this.selectedOnlineTest = [this.openOnlineTestId]
      this.moveTo(to)
    },
    updateOpenOnlineTest(onlineTestId) {
      // this.$store.commit('onlineTest/SET_ACTIVE_ONLINETEST', this.$store.state.onlineTest.onlineTests[onlineTestId])
      this.openOnlineTestId = onlineTestId
      this.isSidebarActive = true
    },
    goTestPage(onlineTestId){
      if(onlineTestId != 0){
        this.openOnlineTestId = onlineTestId
        this.isSidebarActive = true
      }else{
        this.$vs.notify({
          color: 'danger',
          title: '에러',
          text: '등록된 시험이 없습니다'
        })
      }
    },
    toggleEmailSidebar(value = false) {
      if (!value) {
        this.closeMailViewSidebar()
        if (this.clickNotClose) {
          return
        }
      }
      this.isEmailSidebarActive = value
    },
    setDateState(itemIndex, onlineTestInfo, t1){
      var start_time = this.$moment(onlineTestInfo.start_time, 'YYYY-MM-DD HH:mm')
      var end_time = this.$moment(onlineTestInfo.end_time, 'YYYY-MM-DD HH:mm')
      var day = Math.floor(this.$moment.duration(start_time.diff(t1)).asDays())
      var minute = Math.floor(this.$moment.duration(start_time.diff(t1)).asMinutes())
      var end_minute = Math.floor(this.$moment.duration(end_time.diff(t1)).asMinutes())
      var limit = Math.floor(this.$moment.duration(end_time.diff(start_time)).asMinutes())
      if (day > 0){
        this.$store.commit('onlineTest/SET_ONLINETEST_DATE_UPDATE', {index:itemIndex, val:day})
        this.dataStateList.day.push({item:onlineTestInfo, day:day, limit:limit})
      }
      else if(day == 0 && minute > 0){
        var val = Math.floor(minute/60)*-1
        this.$store.commit('onlineTest/SET_ONLINETEST_DATE_UPDATE', {index:itemIndex, val:val})
        this.dataStateList.today.push({item:onlineTestInfo, time:minute, limit:limit})
      }
      else if(minute <= 0 && end_minute >= 0){
        this.$store.commit('onlineTest/SET_ONLINETEST_DATE_UPDATE', {index:itemIndex, val:0})
        this.dataStateList.now.push({item:onlineTestInfo, limit:limit})
      }
      else {
        this.$store.commit('onlineTest/SET_ONLINETEST_DATE_UPDATE', {index:itemIndex, val:-99})
      }
    },
    setActiveOnlinetest(){
      if(this.dataStateList.now.length){
        this.$store.commit('onlineTest/SET_ACTIVE_ONLINETEST', this.dataStateList.now[0].item)
        this.ActiveLimitTime =  this.dataStateList.now[0].limit
      }
      else if (this.dataStateList.today.length) {
        var today = this.dataStateList.today.sort(function(a,b) {return a.time > b.time ? -1 : a.time > b.time ? 1 : 0 })
        this.$store.commit('onlineTest/SET_ACTIVE_ONLINETEST', today[0].item)
        this.ActiveLimitTime =  today[0].limit
      }
      else if (this.dataStateList.day.length) {
        var day = this.dataStateList.day.sort(function(a,b) {return a.day > b.day ? -1 : a.day > b.day ? 1 : 0 })
        this.$store.commit('onlineTest/SET_ACTIVE_ONLINETEST', day[0].item)
        this.ActiveLimitTime =  day[0].limit
      }else{
        this.$store.commit('onlineTest/SET_ACTIVE_ONLINETEST', {title:'준비된 시험이 없습니다',start_time:'', detail:'detail', id:0})
        this.ActiveLimitTime =''
      }
    }
},
  components: {
    quillEditor,
    'onlineTest-item':OnlineTestItem,
    OnlineTestView,
    VuePerfectScrollbar,
    flatPickr,
    moduleOnlineTest,
    vSelect
  },
  beforeDestroy() {
    this.$store.unregisterModule('onlineTest')
  },
  created() {
    this.$store.registerModule('onlineTest', moduleOnlineTest)

    if(this.$store.state.space.ActiveSpaceInfo.id != this.$route.params.spaceId){
      this.$store.dispatch('space/getWorkspace', this.$route.params.spaceId).then(()=>{
        this.$store.dispatch('space/getMembers', {'id' : this.$route.params.spaceId}).then(()=>{
          this.$store.commit('space/SET_ACTIVE_USER_LEVEL', this.$store.state.AppActiveUser.uid)
          if(this.activeUserLevel == 0){
            this.$router.push('/pages/accept/id='+this.activeWorkspace.id+'&title='+this.activeWorkspace.title+'&category=[Workspace]')
          }
        })
      })
    }

    // var t1 = this.$moment(new Date()).format('YYYY-MM-DDTHH:mm')
    var t1 = this.$moment(new Date, 'YYYY-MM-DD HH:mm')
    this.$store.dispatch('onlineTest/getOnlineTest', this.$route.params.spaceId).then(()=>{
      this.onlineTests = this.$store.state.onlineTest.onlineTests
      if(this.onlineTests.length != 0){
        for (var item in this.onlineTests) {
          this.setDateState(item, this.onlineTests[item], t1)
        }
        this.setActiveOnlinetest()
        if (this.$route.params.onlineTestId != 0) {
          this.updateOpenOnlineTest(this.$route.params.onlineTestId)
        }else{
          this.openOnlineTestId = this.onlineTests[0].id
        }
      }
    })
  },
}

</script>




<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";

.filebox label {
  text-align: center;
  width:100%;
  display: inline-block;
  padding: .5em .75em;
  color: #000000;
  font-size: inherit;
  line-height: normal;
  vertical-align: middle;
  background-color: #E7E7E7;
  cursor: pointer;
  border:  solid #E7E7E7 2px;
  border-radius: .25em;
  -webkit-transition: background-color 0.2s;
  transition: background-color 0.2s;
}

.filebox label:hover {
  background-color: #ffffff;
  border:  solid #E7E7E7 2px;
}

.filebox label:active {
  background-color: #ffffff;
  border:   solid #E7E7E7 2px;
}

.filebox input[type="file"] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
#email-app{
    .vs-sidebar--background{
        position: absolute;
    }
    .select-all-chexkbox{
        .vs-checkbox{
            margin-right: 0.8rem;
        }
    }
    .email-filter-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 75px);

        &:not(.ps) {
          overflow-y: auto;
        }
    }

    .email-content-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 100px);

        &:not(.ps) {
          overflow-y: auto;
        }
    }

    .scroll-area-mail-content {
      position: relative;
      margin: auto;
      width: 100%;
      height: calc(100% - 6.3%);

      &:not(.ps) {
        overflow-y: auto;
      }
    }

    .email__mails {
        .mail__opened-mail {
            background-color: #eee;
        }
    }


    .email__mails {

        .email__mail-item {
            transition: all .35s;

            &:not(:first-of-type) {
                .mail__mail-item {
                    border-top: 1px solid #dae1e7;
                }
            }

            .mail__mail-item {
                transition: all 0.2s;


                &:hover {
                    transform: translateY(-4px);
                    box-shadow: 0px 3px 10px 0px #ccc;
                    transition: all 0.2s;
                }

                // Star icon color
                .feather-icon {
                    color: #9c9c9c;
                }
            }
        }
    }

    .email-view-sidebar {
        .vs-sidebar{
            background-color: #f8f8f8 !important;
            border-left: 1px solid #dae1e7;
        }

        .email-header{
            box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.04);
            border-bottom: 1px solid #eee;
            z-index: 1;
            position: relative;
        }

        .open-mail-label {
            transition: all .35s;
        }

        .mail__attachment {
          .vs-chip--text {
            margin-left: 0;
            margin-right: 0;
          }
        }
    }
}
// COMPOSE MAIL DIALOG
.con-vs-dialog.email-compose {
    .vs-dialog {
        max-width: 730px;
        // max-height: 95vh;
        .vs-dialog-text {
            padding: 0;
            .scroll-area {
                max-height: 75vh;
                &:not(.ps) {
                  overflow-y: auto;
                }
            }
            .compose-mail-attachment {
              .con-input-upload {
                margin: 0;
              }
            }
        }
    }
    .con-img-upload {
    .con-input-upload {
      height: 2.5rem;
      width: 100%;
    }
        .img-upload {
            // height: 4rem;
            margin: 0;
            margin-bottom: .5rem;
            margin-right: 1.5rem;
        }
    }
    .quill-editor {
        margin-bottom: 1.5rem
    }
    .ql-editor {
        height: 150px;
    }
}
</style>
